import { Record, List } from 'immutable';
import { DesignVersions } from 'records/DesignVersion';
import { DesignPages } from 'records/DesignPage';

const customersCanvasUrl = APP_CONFIG.ccUrl;

const defaultValues = {
  id: null,
  locationId: null,
  title: '',
  description: '',
  sizeTypeItemId: null,
  sizeTypeName: '', // meta information for wizard
  designTypeItemId: null,
  designTypeName: '', // meta information for wizard
  menuId: null,
  menuDescription: '',
  created: '',
  createdBy: null,
  updated: '',
  updatedBy: null,
  designVersions: DesignVersions(),
  designPages: DesignPages(),
  templateContentId: null, // meta information for wizard
  designPageName: 'Page One', // default first page
  foodTypeName: '', // meta information for wizard
  contentUrl: '', // used in requests for update only
  contentName: '', // used in requests for update only
  ordinal: 0,
  designUpdateTime: '', // missing from api?
  designCreatedTime: '', // missing from api?
  lastUpdatedUser: '', // missing from api?
  templateDescription: '',// Display selected design description in step2
  majorColorTypeItemId: null,
  majorColorTypeItemName: null,
  designThemeId: null,
  designThemeName: '',
  previewUrl: '',
  imported: false,
};

function formatCustomersCanvasUrl(path) {
  const index = path.indexOf('UserDataFolder');
  let url = path.substring(index);
  url = url.replace(/\\/g, '/');
  return `${ customersCanvasUrl }/${ url }`;
}
export default class Design extends Record(defaultValues, Design) {
  constructor(values) {
    super({
      ...values,
      designVersions: values && values.designVersions
                      ? DesignVersions(values.designVersions)
                      : defaultValues.designVersions,
      designPages: values && values.designPages
                      ? DesignPages(values.designPages)
                      : defaultValues.designPages,
      previewUrl: values && values.previewUrl
                      ? formatCustomersCanvasUrl(values.previewUrl)
                      : defaultValues.previewUrl,
    });
  }

  updateDesignKey(key, value) {
    return this.set(`${ key }`, value);
  }

  getCurrentVersionReference() {
    return this.get('designVersions').first();
  }

  getDesignSectionsByPageIndex(index) {
    return this.getIn(['designPages', index, 'designSections']);
  }

  getDesignProductPageDefinition(versionState) {
    let pageDefinitions = new List();
    if (versionState) {
      pageDefinitions = pageDefinitions.push(versionState.replace(/.st/, ''));
      return pageDefinitions.toArray();
    }
    this.get('designPages').forEach((designPage) => {
      pageDefinitions = pageDefinitions.push(designPage.get('contentName').replace(/.st/, ''));
    });
    return pageDefinitions.toArray();
  }

  findDesignItemById(id) {
    const designPages = this.get('designPages');
    let designItems = new List();
    designPages.forEach((designPage) => {
      designPage.get('designSections').forEach((designSection) => {
        designItems = designItems.concat(designSection.get('designItems'));
      });
    });

    return designItems.find((designItem) => {
      return designItem.get('id') === id ? designItem : undefined;
    });
  }

  findDesignItemByMenuItemId(menuItemId) {
    const designPages = this.get('designPages');
    let designItems = new List();
    designPages.forEach((designPage) => {
      designPage.get('designSections').forEach((designSection) => {
        designItems = designItems.concat(designSection.get('designItems'));
      });
    });

    return designItems.find((designItem) => {
      return designItem.get('menuItemId') === menuItemId ? designItem : undefined;
    });
  }

  getContentUrl(stateId) {
    return `CustomerCanvas_share\\UserDataFolder\\${ stateId }`;
  }

  static filterByDesignType(designs, designTypeId) {
    return designs.filter((design) => {
      return design.get('designTypeItemId') === designTypeId;
    });
  }

  static filterByMaxItemNum(designs, maxItemNum) {
    return designs.slice(0,maxItemNum);
  }

  static getDesignById(designs, id) {
    return designs.find((design) => {
      return design.get('id') === id ? design : undefined;
    });
  }

  static getDesignIndexById(designs, id) {
    return designs.findIndex((design) => {
      return design.get('id') === id ? design : undefined;
    });
  }

  static deleteDesignByIndex(designs, index) {
    return designs.delete(index);
  }

  static insertDesignByIndex(designs, index, design) {
    return designs.insert(index, design);
  }

  static sortDesignsByOrdinal(designs) {
    return designs.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static updateDesignOrdinalsFromIndex(designs) {
    return designs.map((item, index) => {
      return item.set('ordinal', index);
    });
  }

  static getNextOrdinal(designs) {
    const items = this.sortDesignsByOrdinal(designs);
    const item = items.last();
    if (item) {
      return item.get('ordinal') + 1;
    }
    return 0;
  }

  static formatDesignsForOrdinalUpdate(designs) {
    const designData = {
      ids: [],
    };
    designs.forEach((item) => {
      designData.ids.push(item.get('id'));
    });
    return designData;
  }

  static updateDesignAfterChangeBkgd(latestDesign, design) {
    let changedBackgroundDesign = latestDesign;
    changedBackgroundDesign.get('designPages').map((designPage, pageIndex) => {
      if(design.getIn(['designPages', pageIndex, 'updatedTemplateId'])) {
        changedBackgroundDesign = changedBackgroundDesign.setIn(['designPages', pageIndex, 'updatedContentName'], design.getIn(['designPages', pageIndex, 'updatedContentName']));
        changedBackgroundDesign = changedBackgroundDesign.setIn(['designPages', pageIndex, 'templateDescription'], design.getIn(['designPages', pageIndex, 'templateDescription']));
        changedBackgroundDesign = changedBackgroundDesign.setIn(['designPages', pageIndex, 'updatedTemplateId'], design.getIn(['designPages', pageIndex, 'updatedTemplateId']));
        changedBackgroundDesign = changedBackgroundDesign.setIn(['designPages', pageIndex, 'updatedPreviewUrl'], design.getIn(['designPages', pageIndex, 'updatedPreviewUrl']));
      }
    });
    return changedBackgroundDesign;
  }
}

export const Designs = (data) => {
  let designs = new List();
  if (data) {
    data.forEach((value) => {
      designs = designs.push(new Design(value));
    });
  }
  return designs;
};
